<template>
  <main class="single-film-prototype not-found-page">
    <section class="not-found-page__top g-0 position-relative">
      <HeroTopPanel
        :logo-src="logoPath"
        :login-path="loginPath"
        :show-background="false"
        content-class="not-found-page__hero-content"
        @open-mobile-search="openMobileSearchOverlay"
      >
        <section class="not-found-page__body">
          <p class="not-found-page__code" data-testid="not-found-title">{{ title }}</p>
          <h1 class="not-found-page__heading">{{ heading }}</h1>
          <p class="not-found-page__message" data-testid="not-found-message">{{ message }}</p>
          <div class="not-found-page__actions">
            <a class="not-found-page__action" href="/discover">Discover</a>
            <a class="not-found-page__action not-found-page__action--secondary" href="/">Home</a>
          </div>
        </section>
      </HeroTopPanel>
    </section>
    <MobileSearchOverlay :open="mobileSearchOpen" @close="closeMobileSearchOverlay" />
  </main>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import HeroTopPanel from '../components/HeroTopPanel.vue'
import MobileSearchOverlay from '../components/MobileSearchOverlay.vue'
import '../assets/single-film/bootstrap-lite.css'
import '../assets/single-film/styles.css'
import { buildLoginPath } from '../utils/auth'

defineProps({
  title: {
    type: String,
    default: '404',
  },
  heading: {
    type: String,
    default: 'Page was not found',
  },
  message: {
    type: String,
    default: 'The page you were looking for could not be found.',
  },
})

const route = useRoute()
const logoPath = '/static/spa/branding/logo.png'
const loginPath = computed(() => buildLoginPath(route.fullPath || '/'))
const mobileSearchOpen = ref(false)

function openMobileSearchOverlay() {
  mobileSearchOpen.value = true
}

function closeMobileSearchOverlay() {
  mobileSearchOpen.value = false
}
</script>
